module.exports = __webpack_public_path__ + "static/quiz_mid-5191dd5f21bc4df89e99437422876bf4.jpg";